var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26197",
    "data-name": "Group 26197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.086,
    height: 150.086,
    viewBox: "0 0 150.086 150.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 75.043,
    cy: 75.043,
    rx: 75.043,
    ry: 75.043,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_67_-_Outline",
    "data-name": "Ellipse 67 - Outline",
    d: "M75.043,4.69A70.353,70.353,0,0,0,25.3,124.79,70.353,70.353,0,0,0,124.79,25.3,69.892,69.892,0,0,0,75.043,4.69m0-4.69A75.043,75.043,0,1,1,0,75.043,75.043,75.043,0,0,1,75.043,0Z",
    transform: "translate(0)",
    fill: "#ffd055"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18873",
    "data-name": "Path 18873",
    d: "M61.441.239A1.4,1.4,0,0,0,59.942.2L3.012,33.976a1.4,1.4,0,0,0,.339,2.557L17.817,40.56a1.406,1.406,0,0,0,1.264-.265l23.11-18.879L26.07,41.993a1.4,1.4,0,0,0-.3.865v18.48a1.4,1.4,0,0,0,1.01,1.346,1.367,1.367,0,0,0,.392.056,1.4,1.4,0,0,0,1.182-.649l10.064-15.8,14.713,4.1A1.405,1.405,0,0,0,54.9,49.245L62.044,1.611A1.4,1.4,0,0,0,61.441.239Z",
    transform: "translate(38.161 48.363)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSent);
export default __webpack_public_path__ + "static/media/chat-sent.f68a6b949316fc49074b67d9ddd6fcd0.svg";
export { ForwardRef as ReactComponent };